import React from 'react';
import { Button as AntButton } from 'antd';
import styleStudio from './button.module.sass';
import styleFlow from './buttonFlow.module.sass';

interface IProps {
    onClick?: any,
    children?: any,
    color?: 'primary' | 'secondary' | 'danger' | 'success' | 'light' | 'dark' | 'shadow-primary' | 'shadow-secondary' | 'primary-light-outlined' | 'light-secondary' | 'secondary-outlined' | 'primary-outlined'
    size?: 'large' | 'small' | 'round' | 'extra-small',
    from: string;
    icon?: string;
    disabled?: boolean;
}

export const Button = (props: IProps) => {
    const style = (props.from === 'studio') ? styleStudio : styleFlow
    const baseClass = style.button


    let typeClass: any;
    if (props.size === 'small') {
        typeClass = style.small
    } else if (props.size === 'extra-small') {
        typeClass = style.extraSmall
    } else if (props.size === 'large') {
        typeClass = style.large
    } else if (props.size === 'round') {
        typeClass = style.round
    }

    let colorClass: any;
    if (props.color === 'light') {
        colorClass = style.light
    } else if (props.color === 'shadow-primary') {
        colorClass = style.shadowPrimary
    } else if (props.color === 'shadow-secondary') {
        colorClass = style.shadowSecondary
    } else if (props.color === 'primary-light-outlined') {
        colorClass = style.primaryLightOutlined
    } else if (props.color === 'light-secondary') {
        colorClass = style.lightSecondary
    } else if (props.color === 'secondary-outlined') {
        colorClass = style.secondaryOutlined
    } else if (props.color === 'primary-outlined') {
        colorClass = style.primaryOutlined
    }

    const className = `${baseClass} ${typeClass ? typeClass : ''} ${colorClass ? colorClass : ''}`

    const { onClick, icon, disabled, children } = props;
    const buttonProps = { onClick, icon, disabled, className }

    return (
        <AntButton {...buttonProps}>
            {
                (typeof children === 'string') ?
                    children.toUpperCase()
                    :
                    children
            }
        </AntButton>
    )
}
